import { useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const RejectDialogActions = ({ sending, canSend, onCancel, onSend }) => (
  <DialogActions sx={{ px: 3, pb: 2 }}>
    <Button onClick={onCancel} disabled={sending}>
      ביטול
    </Button>
    <Button
      variant="contained"
      color="error"
      onClick={onSend}
      disabled={!canSend || sending}
      startIcon={sending ? <CircularProgress size={16} color="inherit" /> : <CancelIcon />}
    >
      {sending ? "שולח..." : "שלח דחייה"}
    </Button>
  </DialogActions>
);

const RejectNoteField = ({ note, onChange, disabled, error }) => (
  <>
    <Typography variant="body2" color="text.secondary" mb={2}>
      ההזמנה תישאר בסטטוס השהיית סחר. הסיבה תישלח במייל לסוכן ולמנהל האחראי.
    </Typography>
    <TextField
      autoFocus
      multiline
      minRows={3}
      fullWidth
      label="סיבת הדחייה / הודעה לסוכן"
      value={note}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
    {error && (
      <Typography variant="caption" color="error" sx={{ display: "block", mt: 1 }}>
        {error}
      </Typography>
    )}
  </>
);

// Reject = no change in Priority; the backend emails the responsible
// manager(s) + the order's agent with this note.
const RejectOrderDialog = ({ open, ordname, onClose, onReject }) => {
  const [note, setNote] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    if (sending) return;
    setNote("");
    setError(null);
    onClose();
  };

  const handleSubmit = async () => {
    setSending(true);
    setError(null);
    try {
      await onReject(ordname, note.trim());
      setNote("");
      onClose();
    } catch (err) {
      setError(err?.msg || err?.message || "שגיאה בשליחת הדחייה");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth dir="rtl">
      <DialogTitle sx={{ fontWeight: 700 }}>דחיית הזמנה {ordname}</DialogTitle>
      <DialogContent>
        <RejectNoteField note={note} onChange={setNote} disabled={sending} error={error} />
      </DialogContent>
      <RejectDialogActions sending={sending} canSend={!!note.trim()} onCancel={handleClose} onSend={handleSubmit} />
    </Dialog>
  );
};

export default RejectOrderDialog;
